module.exports = __webpack_public_path__ + "img/pay.01214d3d.png";